import { ResizeSensor } from 'css-element-queries';
import { importPlotly } from './Plotly';

let Plotly;

export default {
  props: {
    margins: {
      type: Object,
      default: () => ({
        l: 70, b: 120, r: 30, t: 100,
      }),
    },
  },
  data() {
    return {
      canResize: false,
      readyToDisplay: false,
      resizeSensor: null,
    };
  },
  methods: {
    async resize() {
      if (Plotly && this.canResize && this.$refs.element) {
        Plotly.Plots.resize(this.$refs.element).then(() => {
          this.readyToDisplay = true;
        });
      }
    },
  },
  async mounted() {
    // Add the sensor to know if the container has been resized
    this.resizeSensor = new ResizeSensor(this.$el, this.resize);
    ({ Plotly } = await importPlotly());
  },
  beforeDestroy() {
    this.resizeSensor.detach(this.$el);
    if (Plotly && this.$refs.element) {
      Plotly.purge(this.$refs.element);
    }
  },
};
